import { render, staticRenderFns } from "./PageSearch.vue?vue&type=template&id=62decf43&lang=pug&"
import script from "./PageSearch.vue?vue&type=script&lang=js&"
export * from "./PageSearch.vue?vue&type=script&lang=js&"
import style0 from "./PageSearch.vue?vue&type=style&index=0&id=62decf43&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62decf43')) {
      api.createRecord('62decf43', component.options)
    } else {
      api.reload('62decf43', component.options)
    }
    module.hot.accept("./PageSearch.vue?vue&type=template&id=62decf43&lang=pug&", function () {
      api.rerender('62decf43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/interface/header/PageSearch.vue"
export default component.exports